jQuery(function ($) {
  function initSlick(selector, settings) {
    const $el = $(selector);
    if ($el.length && !$el.hasClass('slick-initialized')) {
      $el.slick(settings);
    }
  }

  // -------------------------
  // COMMON LOOP SETTINGS
  // -------------------------
  const commonLoop = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    // speed: 8000,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    pauseOnHover: false,
    pauseOnFocus: false,
  };

  // -------------------------
  // INIT SLIDERS
  // -------------------------
  // initSlick('.partner-slider', {
  //   ...commonLoop,
  //   slidesToShow: 5,
  //   variableWidth: true,
  //   centerMode: true,
  //   speed: 3000,
  //   draggable: true,
  //   swipeToSlide: true,
  //   touchMove: true,
  //   responsive: [
  //     { breakpoint: 1024, settings: { slidesToShow: 4 } },
  //     { breakpoint: 768, settings: { slidesToShow: 3 } },
  //     { breakpoint: 480, settings: { slidesToShow: 2 } },
  //   ],
  // });

  initSlick('.project-gallery__slider', {
    ...commonLoop,
    slidesToShow: 3,
    variableWidth: true,
    speed: 16000,
    responsive: [{ breakpoint: 480, settings: { slidesToShow: 1 } }],
  });

  initSlick('.story-gallery__slider', {
    ...commonLoop,
    slidesToShow: 3,
    variableWidth: true,
    responsive: [{ breakpoint: 480, settings: { slidesToShow: 1 } }],
  });

  initSlick('.testimonial__slider', {
    speed: 8000,
    arrows: true,
    dots: false,
    slidesToShow: 1,
    variableWidth: false,
    centerMode: true,
    centerPadding: '0px',
    responsive: [{ breakpoint: 480, settings: { slidesToShow: 1 } }],
  });

  // slide pause on mouse enter
  // const $slider = $('.partner-slider, .project-gallery__slider');
  const $slider = $('.project-gallery__slider');

  $slider.on('mouseenter', function () {
    const $el = $(this);

    // stop autoplay immediately
    $el.slick('slickPause');

    // freeze current position (important)
    const $track = $el.find('.slick-track');
    const matrix = $track.css('transform');

    $track.css({
      transform: matrix,
    });
  });

  $slider.on('mouseleave', function () {
    const $el = $(this);

    const $track = $el.find('.slick-track');

    // restore normal movement
    $track.css({
      transform: '',
    });

    $el.removeClass('is-paused');

    // force slick to continue from same position
    $el.slick('setPosition');
    $el.slick('slickPlay');
  });
});

// ==========================
// PARTNER SLIDER
// ==========================
document.addEventListener('DOMContentLoaded', function () {
  gsap.registerPlugin(Draggable, InertiaPlugin);

  const marquee = document.querySelector('.partner-track');
  const track = document.querySelector('.partner-slider');
  const allItems = document.querySelectorAll('.partner-slide-item');
  const proxy = document.createElement('div');

  if (!marquee || !track || !allItems.length) return;

  const direction = 'to-left';
  const directionVal = direction === 'to-left' ? -1 : 1;

  let totalX = 0;
  let marqueeH = 0;

  // Set item positions
  allItems.forEach((item) => {
    const itemW = item.offsetWidth;
    const itemH = item.offsetHeight;

    gsap.set(item, {
      x: totalX,
      width: itemW,
      height: itemH,
    });

    totalX += itemW - itemW * 0.05;

    if (itemH > marqueeH) {
      marqueeH = itemH;
    }
  });

  const wrapX = gsap.utils.wrap(0, totalX);
  const wrapProgress = gsap.utils.wrap(0, 1);

  gsap.set(marquee, {
    height: marqueeH,
  });

  const moveX = directionVal === -1 ? `-=${totalX}` : `+=${totalX}`;
  const animation = gsap.to('.partner-slide-item', {
    x: moveX,
    duration: 150,
    ease: 'none',
    repeat: -1,
    paused: true,
    modifiers: {
      x(value, target) {
        let x = parseInt(value);

        if (directionVal === -1) {
          x = ((x - totalX) % totalX) + (totalX - target.offsetWidth);
        } else {
          x = x % totalX;
        }

        // Hide items outside viewport
        target.style.visibility = x > marquee.offsetWidth ? 'hidden' : 'visible';

        return x + 'px';
      },
    },
  });

  function updateProgress() {
    const dragValue = wrapX(this.deltaX * directionVal) / totalX;
    const current = animation.progress();
    animation.progress(wrapProgress(current + dragValue));
  }

  Draggable.create(proxy, {
    type: 'x',
    trigger: '.partner-track',
    inertia: true,

    onDrag: updateProgress,
    onThrowUpdate: updateProgress,
  });

  function resize() {
    animation.render(animation.time(), false, true);
  }

  window.addEventListener('resize', resize);

  // autoplay
  animation.play();
  // Pause on hover
  marquee.addEventListener('mouseenter', () => {
    animation.pause();
  });

  // Resume when mouse leaves (only if not dragging)
  marquee.addEventListener('mouseleave', () => {
    animation.play();
  });
});
